import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { Icon, LegalConsent } from '@carrent/ui'
import { useLoginForm, DEMO_ACCOUNTS, useLegal, fetchLegalDocument } from '@carrent/domain'

export default function LoginPage() {
  const navigate = useNavigate()
  const [showDemo, setShowDemo] = useState(false)
  const { legal } = useLegal()

  // Водительское приложение всегда ведёт на свою главную,
  // независимо от роли: администратор тоже может быть за рулём.
  const form = useLoginForm(() => navigate('/', { replace: true }))

  return (
    <div className="auth-screen">
      <div className="auth-brand">
        <span className="auth-brand__mark" aria-hidden="true">
          <Icon name="car" size={34} />
        </span>
        <h1 className="auth-brand__title">CarRent</h1>
        <p className="auth-brand__subtitle">Вход для водителей</p>
      </div>

      <form className="auth-form flex-col gap" onSubmit={form.submit}>
        <div className="field">
          <label className="field__label" htmlFor="phone">
            Телефон
          </label>
          <input
            id="phone"
            className="input"
            type="tel"
            inputMode="tel"
            autoComplete="username"
            placeholder="+7 900 000-00-00"
            value={form.phone}
            onChange={(e) => form.setPhone(e.target.value)}
            aria-invalid={Boolean(form.error)}
          />
        </div>

        <div className="field">
          <label className="field__label" htmlFor="password">
            Пароль
          </label>
          <input
            id="password"
            className="input"
            type="password"
            autoComplete="current-password"
            value={form.password}
            onChange={(e) => form.setPassword(e.target.value)}
            aria-invalid={Boolean(form.error)}
          />
        </div>

        {form.error && (
          <div className="alert alert--error" role="alert">
            {form.error}
          </div>
        )}

        <button type="submit" className="btn btn--primary btn--full" disabled={form.loading}>
          {form.loading ? <span className="spinner spinner--sm" /> : null}
          {form.loading ? 'Входим…' : 'Войти'}
        </button>

        <p className="auth-hint">
          Нет аккаунта? <Link to="/register">Зарегистрироваться</Link>
        </p>

        <LegalConsent legal={legal} fetchDocument={fetchLegalDocument} />
      </form>

      {/* Панель существует только в dev-сборке: DEMO_ACCOUNTS
          вычисляется через import.meta.env.DEV и в проде пуст. */}
      {DEMO_ACCOUNTS.length > 0 && (
        <div className="auth-demo">
          <button
            type="button"
            className="btn btn--ghost btn--sm"
            onClick={() => setShowDemo((v) => !v)}
            aria-expanded={showDemo}
          >
            {showDemo ? 'Скрыть' : 'Показать'} тестовые учётки
          </button>

          {showDemo && (
            <div className="auth-demo__list">
              {DEMO_ACCOUNTS.map((a) => (
                <button
                  key={a.phone}
                  type="button"
                  className="chip"
                  onClick={() => form.prefill(a)}
                >
                  {a.label}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}
